import { combineReducers } from 'redux';
import createSaga from './saga';
import { createReduceObject as createReqStatusReduceObject } from '../../../../common/reducers/_requestStatus/reducer';
import { createReduceObject as createListReduceObject } from '../../../../common/reducers/_list/reducer';
import { createReduceObject as createPaginationReduceObject } from '../../../../common/reducers/_pagination/reducer';
import { createReduceObject as createChildCommentsReduceObject } from '../../../../common/reducers/__childMultipleList/reducer';
import { reducerRegistry } from '../../../../reducerRegistry';

export const createReducerName = name => `comments/${name}`;
export const childCommentsReduceName = 'childComments';

export function createCombineReducers(reducerName) {
  const combine = combineReducers({
    ...createReqStatusReduceObject(reducerName),
    ...createListReduceObject(reducerName),
    ...createChildCommentsReduceObject(reducerName, childCommentsReduceName),
    ...createPaginationReduceObject(reducerName)
  });
  reducerRegistry.register(reducerName, combine, createSaga);
}

export function removeCombineReducers(reducerName) {
  reducerRegistry.remove(reducerName);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/comments/reducers/list/reducer.js